<template>
  <div class="senior-management">
    <fieldset class="info-group senior-top"
              v-if="kycStatus==='saved' || kycStatus==='submitted'">
      <legend class="senior-title">{{ $t("kyc.majorPersonnelInformation") }}</legend>
    </fieldset>
    <fieldset class="info-group senior-top">
      <legend class="senior-title">
        <span :class="(kycStatus==='saved' || kycStatus==='submitted')?'saved-title':''">{{ $t("kyc.section.seniorManagement") }}</span>
      </legend>
      <div class="senior-buttons"
           v-if="kycStatus!== 'submitted'">
        <button class="btn btn-primary btn-sm "
                @click="addSenior">{{ $t("kyc.add") }}</button>
        <button class="btn btn-danger btn-sm "
                @click="deleteSelected">{{ $t("delete") }}</button>
      </div>
    </fieldset>
    <vuestic-widget id="dategridPayOrder">
      <div>
        <table class="table table-striped first-td-padding"
               id="seniorTable">
          <thead>
            <tr>
              <th>
                <input type="checkbox"
                       @change="seniorCheckAll">
              </th>
              <th v-for="(item,index) in tableHeaderList"
                  :key="index"
                  v-show="!(kycStatus==='submitted' && item.label === 'kyc.seniorManagement.action')">
                {{ item.label | translate}}
              </th>
            </tr>
          </thead>
          <tbody v-if="isList">
            <tr v-for="(item,index) in seniorManagementList"
                :key="index">
              <td>
                <input type="checkbox"
                       :value="item.trade_no"
                       :checked="item.checked"
                       @change="seniorCheckOne(arguments[0], index)">
              </td>
              <td>{{item.name}}</td>
              <td>{{item.position}}</td>
              <td>{{ getIdTypeKey(item.id_type)}}</td>
              <td>{{ item.id_number }}</td>
              <td>{{item.residence_address}}</td>
              <td>{{item.is_pep===1?'Yes':'No'}}</td>
              <td>{{item.is_sanction===1?'Yes':'No'}}</td>
              <td>{{item.is_crime===1?'Yes':'No'}}</td>
              <td> <!--id_proof_file_list-->
                <div class="action-button">
                  <img :src="eyeIcon"
                       alt=""
                       @click="showSeniorFile(index, 'id_proof')">
                </div>
              </td>
              <td> <!--address_proof_file_list-->
                <div class="action-button">
                  <img :src="eyeIcon"
                       alt=""
                       @click="showSeniorFile(index, 'address_proof')">
                </div>
              </td>
              <td v-show="kycStatus!=='submitted'" class="senior-td-button">
                <div class="action-button">
                  <img :src="copyIcon"
                       alt=""
                       @click="copyFunc(index)"
                       @mouseenter="seniorCopyEnter(index)"
                       @mouseleave="seniorCopyLeave(index)">
                  <img :src="editIcon"
                       alt=""
                       @click="editSenior(index)">
                  <img :src="deleteIcon"
                       alt=""
                       @click="deleteFunc(index)">
                </div>
                <div :ref="'seniorCopyFlag-' + index"
                     class="senior-copy-none">{{ $t("kyc.copyToTheNextList") }}</div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11"
                  v-text="$t('t.noDataNoOrder')"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="block"
           v-if="isMobile === 'pc'">
        <pagination v-show="total>0"
                    :total="total"
                    :page-size="limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :page.sync="page"
                    :limit.sync="limit"
                    @pagination="orderData" />
      </div>
      <div class="block"
           v-else>
        <pagination v-show="total>0"
                    :total="total"
                    layout="total, prev, pager, next"
                    background
                    :page.sync="page"
                    :limit.sync="limit"
                    @pagination="orderData" />
      </div>
    </vuestic-widget>

    <vuestic-modal :show.sync="seniorAddshow"
                   ref="seniorAdd"
                   :okText="'modal.confirm2' | translate"
                   style="height: 100%;width:60vw;"
                   :okClass="'btn btn-primary btn-micro'"
                   :cancelClass="'btn btn-secondary btn-micro'"
                   :cancelText="'modal.cancel2' | translate"
                   alignModal="">
      <div slot="title">{{seniorAddTitle}}</div>
      <div>
        <form>
          <div class="va-row">
            <div class="flex xs12 md12">
              <fieldset>

                <div class="info-group">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('name'), 'valid': isFormFieldValid('name')}">
                    <div class="input-group">
                      <input id="nameInput"
                             name="name"
                             data-vv-as="Name"
                             v-model="addSeniorManage.name"
                             autocomplete="off"
                             v-validate="'required'"
                             required />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="name">Name：</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('name')"
                             class="help text-danger">{{ errors.first('name') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('position'), 'valid': isFormFieldValid('position')}">
                    <div class="input-group">
                      <input id="positionInput"
                             name="position"
                             data-vv-as="Position"
                             v-model="addSeniorManage.position"
                             autocomplete="off"
                             v-validate="'required'"
                             required />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="position">{{ $t("kyc.seniorManagement.position") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('position')"
                             class="help text-danger">{{ errors.first('position') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': initIdTypeVaild, 'valid': isIdTypeVaild('idType')}">
                    <div class="input-group">
                      <vuestic-kyc-select id="idTypeInput"
                                          name="idType"
                                          data-vv-as="ID Type"
                                          v-validate="'required'"
                                          required
                                          :label="$t('kyc.seniorManagement.idType') + '：'"
                                          v-model="addSeniorManage.idType"
                                          option-key="value"
                                          :options="idTypeOptions"
                                          ref="myInput"
                                          autocomplete="off"
                                          @input="(val)=>{idTypeStatus = !val?true:false}" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa icon-right input-icon"></i>
                      <small v-show="initIdTypeVaild"
                             class="help text-danger">{{ errors.first('idType') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('idNumber'), 'valid': isFormFieldValid('idNumber')}">
                    <div class="input-group">
                      <input id="idNumberInput"
                             name="idNumber"
                             data-vv-as="ID Number"
                             v-model="addSeniorManage.idNumber"
                             autocomplete="off"
                             v-validate="'required'"
                             required />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="idNumber">{{ $t("kyc.seniorManagement.idNumber") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('idNumber')"
                             class="help text-danger">{{ errors.first('idNumber') }}</small>
                    </div>
                  </div>
                </div>

                <div class="form-group with-icon-right"
                     :class="{'has-error': errors.has('residenceAddress'), 'valid': isFormFieldValid('residenceAddress')}">
                  <div class="input-group">
                    <input id="residenceAddressInput"
                           name="residenceAddress"
                           data-vv-as="Residence Address"
                           v-model="addSeniorManage.residenceAddress"
                           autocomplete="off"
                           v-validate="'required'"
                           required />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label"
                           for="residenceAddress">{{ $t("kyc.seniorManagement.residenceAddress") }}</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('residenceAddress')"
                           class="help text-danger">{{ errors.first('residenceAddress') }}</small>
                  </div>
                </div>

                <div class="info-group">
                  <div class="form-group mb0" :class="{'has-error': idProofStatus, 'valid': idProofStatus}">
                    <label for="idProof"
                           class="control-label upload-label app-logo-label-kyc">ID Proof：</label>
                    <div class="app-logo-wrapper-kyc">
                      <vuestic-file-upload-kyc id="idProof"
                                               type="list"
                                               v-model="addSeniorManage.idProof"
                                               ref="fieldInput"
                                               @input="uploadFile(arguments[0], 'idProof')"
                                               @removeFile="removeFile(arguments[0], 'idProof')" />
                      <small v-show="idProofStatus"
                              class="help text-danger">{{ $t("kyc.theIdProofFieldIsRequired") }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group">
                  <div class="form-group mb0" :class="{'has-error': addressProofStatus, 'valid': addressProofStatus}">
                    <label for="idProof"
                           class="control-label upload-label app-logo-label-kyc">Address Proof：</label>
                    <div class="app-logo-wrapper-kyc">
                      <vuestic-file-upload-kyc id="addressProof"
                                               type="list"
                                               v-model="addSeniorManage.addressProof"
                                               ref="fieldInput"
                                               @input="uploadFile(arguments[0], 'addressProof')"
                                               @removeFile="removeFile(arguments[0], 'addressProof')" />
                      <small v-show="addressProofStatus"
                              class="help text-danger">{{ $t("kyc.theAddressProofFieldIsRequired") }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': initPepVaild, 'valid': isPepVaild('pep')}">
                    <div class="input-group">
                      <vuestic-kyc-select id="pepInput"
                                          name="pep"
                                          data-vv-as="pep"
                                          v-validate="'required'"
                                          required
                                          :label="$t('kyc.isAPep')"
                                          v-model="addSeniorManage.pep"
                                          option-key="value"
                                          :options="commonOptions"
                                          ref="myInput"
                                          autocomplete="off"
                                          @input="(val)=>{pepStatus = !val?true:false}" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa icon-right input-icon"></i>
                      <small v-show="initPepVaild"
                             class="help text-danger">{{ errors.first('pep') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': initSanctionVaild, 'valid': isSanctionVaild('sanction')}">
                    <div class="input-group">
                      <vuestic-kyc-select id="sanctionInput"
                                          name="sanction"
                                          data-vv-as="sanction"
                                          v-validate="'required'"
                                          required
                                          :label="$t('kyc.inASanctionList')"
                                          v-model="addSeniorManage.sanction"
                                          option-key="value"
                                          :options="commonOptions"
                                          ref="myInput"
                                          autocomplete="off"
                                          @input="(val)=>{sanctionStatus = !val?true:false}" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa icon-right input-icon"></i>
                      <small v-show="initSanctionVaild"
                             class="help text-danger">{{ errors.first('sanction') }}</small>
                    </div>
                  </div>

                </div>

                <div class="info-group">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': initCrimeVaild, 'valid': isCrimeVaild('crime')}">
                    <div class="input-group">
                      <vuestic-kyc-select id="crimeInput"
                                          name="crime"
                                          data-vv-as="crime"
                                          v-validate="'required'"
                                          required
                                          :label="$t('kyc.anyCrime')"
                                          v-model="addSeniorManage.crime"
                                          option-key="value"
                                          :options="commonOptions"
                                          ref="myInput"
                                          autocomplete="off"
                                          @input="(val)=>{crimeStatus = !val?true:false}" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa icon-right input-icon"></i>
                      <small v-show="initCrimeVaild"
                             class="help text-danger">{{ errors.first('crime') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"></div>
                </div>

              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </vuestic-modal>
    <large-image :isShowFileImage="isShowFileImage"
                 :filesList="fileArr"
                 :bigImage="bigImage"
                 :curFile="curFile"
                 :fileUrl="fileUrl"
                 @closeLargeImage="closeFileImage"
                 @showImage="showImageInit" />
  </div>

</template>
<script>
import { request } from '@/utils/utils.js'
import Pagination from '@/components/Pagination'
import simpleSelect from './components/simple-select.vue'
import vuesticFileUploadKyc from '../../../vuestic-theme/vuestic-components/vuestic-file-upload-kyc/VuesticFileUpload'
import largeImage from './components/large-image.vue'
import mixin from '../mixins/mixin'
var moment = require('moment-timezone')
export default {
  inject: ['merchantNo'],
  mixins: [mixin],
  props: {
    kycStatus: {
      type: String,
    },
    merchantData: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    Pagination,
    vuesticFileUploadKyc,
    simpleSelect,
    largeImage,
  },
  data () {
    return {
      copyIcon: require('../../../assets/images/copy.png'),
      deleteIcon: require('../../../assets/images/delete.png'),
      editIcon: require('../../../assets/images/edit.png'),
      eyeIcon: require('../../../assets/images/eye.png'),
      tableHeaderList: [
        {
          label: 'kyc.seniorManagement.name',
          key: 'Name',
          id: 0,
        },
        {
          label: 'kyc.seniorManagement.position',
          key: 'Position',
          id: 1,
        },
        { label: 'kyc.seniorManagement.idType', key: 'ID Type', id: 2 },
        {
          label: 'kyc.seniorManagement.idNumber',
          key: 'ID Number',
          id: 3,
        },
        {
          label: 'kyc.seniorManagement.residenceAddress',
          key: 'Residence Address',
          id: 4,
        },
        {
          label: 'kyc.seniorManagement.pep',
          key: 'PEP',
          id: 5,
        },
        {
          label: 'kyc.seniorManagement.sanction',
          key: 'Sanction',
          id: 6,
        },
        {
          label: 'kyc.seniorManagement.crime',
          key: 'Crime',
          id: 7,
        },
        {
          label: 'kyc.seniorManagement.idProof',
          key: 'ID Proof',
          id: 8,
        },
        {
          label: 'kyc.seniorManagement.addressProof',
          key: 'Address Proof',
          id: 9,
        },
        {
          label: 'kyc.seniorManagement.action',
          key: 'Action',
          id: 10,
        },
      ],
      seniorManagementList: [], // 请求回来填充表格的数据
      isList: true,
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 99999, // 默认一次显示12条数据

      value_mode: '',
      value_time: '',
      searchVal: '',
      addSeniorManage: {
        name: '',
        position: '',
        idType: '',
        idNumber: '',
        residenceAddress: '',
        idProof: '',
        addressProof: '',
        pep: '',
        sanction: '',
        crime: '',
      },
      seniorAddshow: true,
      // 弹框多选
      idTypeOptions: [
        {
          id: 1,
          value: 'ID'
        }, {
          id: 2,
          value: 'Passport'
        }, {
          id: 3,
          value: "Driver's License"
        }, {
          id: 4,
          value: 'Other'
        }
      ],
      commonOptions: [
        {
          id: 0,
          value: 'No'
        },
        {
          id: 1,
          value: 'Yes'
        }
      ],
      idTypeStatus: false,
      pepStatus: false,
      sanctionStatus: false,
      crimeStatus: false,
      checkOne: false,
      isShowFileImage: false,
      bigImage: '',
      curFile: null,
      fileArr: [],
      seniorAddTitle: '',
      idProofStatus: false,
      addressProofStatus: false,
      seniorFileArray: [ 'idProof', 'addressProof' ],
      editIndex: 'null',
      fileUrl: '',
      seniorCopyFlag: false
    }
  },
  mounted () {
    let that = this
    if (that.kycStatus === 'firstEdit') {
      that.getMerchantKYCInfo(6, res => {
        if (res.senior_management_list) {
          that.seniorManagementList = res.senior_management_list
        } else {
          that.seniorManagementList = []
        }
      })
    } else if (that.merchantData.senior_management_list) {
      that.seniorManagementList = that.merchantData.senior_management_list
    } else {}
    that.$refs.seniorAdd.ok = () => {
      that.$validator.validateAll().then((result) => {
        if (that.checkAddSenior() && result) {
          let params = {
            'address_proof_file_list': that.addSeniorManage.addressProof,
            'id_number': that.addSeniorManage.idNumber,
            'id_proof_file_list': that.addSeniorManage.idProof,
            'id_type': that.addSeniorManage.idType.id,
            'is_crime': that.addSeniorManage.crime.id,
            'is_pep': that.addSeniorManage.pep.id,
            'is_sanction': that.addSeniorManage.sanction.id,
            'name': that.addSeniorManage.name,
            'position': that.addSeniorManage.position,
            'residence_address': that.addSeniorManage.residenceAddress,
            'statement_of_good_conduct': 0
          }
          if (that.editIndex !== 'null') {
            that.seniorManagementList[that.editIndex] = params
          } else {
            that.seniorManagementList.push(params)
          }

          that.$refs.seniorAdd.close()
          that.$validator.reset()
          that.seniorFileArray.forEach((type) => that.changeStatusByType(type, false))
        }
      })
    }
  },
  computed: {
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return 'mobile'
      }
      return 'pc'
    },
    // 多选框 开始
    initIdTypeVaild () {
      return this.idTypeStatus
    },
    initPepVaild () {
      return this.pepStatus
    },
    initSanctionVaild () {
      return this.sanctionStatus
    },
    initCrimeVaild () {
      return this.crimeStatus
    },
    // 多选框结束
  },
  methods: {
    searchOrder () {
      this.page = 1
      this.loadingFullScreen('searching', 'Searching', 'fa fa-hourglass-half')
      // this.orderData()
    },
    fetchDetails (itemId) {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      localStorage.setItem('tid', itemId)
      this.getOrderInfoById(
        this.$route.params.tid || localStorage.getItem('tid')
      )
    },
    dateFormat (value) {
      return moment
        .tz(moment.tz(value, 'UTC'), this.currTimeZone)
        .format('YYYY-MM-DD HH:mm:ss')
    },
    getStatusColor (status) {
      if (status == 'Success') {
        return 'success'
      }
      if (
        status == 'Dispute' ||
        status == 'Controlling' ||
        status == 'Cancelled'
      ) {
        return 'warning'
      }
      if (
        status == 'Refused' ||
        status == 'Refunded' ||
        status == 'ChargeBack' ||
        status == 'Fail' ||
        status == 'PayFail'
      ) {
        return 'danger'
      }
      return 'info'
    },
    orderData () {},
    // 新增功能
    addSenior () {
      this.editIndex = 'null'
      this.seniorAddTitle = 'Add'
      this.$refs.seniorAdd.open()
      this.$validator.reset()
      this.idTypeStatus = false
      this.pepStatus = false
      this.sanctionStatus = false
      this.crimeStatus = false
      this.idProofStatus = false
      this.addressProofStatus = false
      this.addSeniorManage = {
        name: '',
        position: '',
        idType: '',
        idNumber: '',
        residenceAddress: '',
        idProof: '',
        addressProof: '',
        pep: '',
        sanction: '',
        crime: '',
      }
      // this.$refs.mediumModal.close();
    },
    checkAddSenior () {
      let that = this
      try {
        let seniorArray = ['idType', 'pep', 'sanction', 'crime']
        let isValidate = seniorArray.reduce((result, current) => {
          if (!that.addSeniorManage[current]) {
            that[current + 'Status'] = true
          } else {
            that[current + 'Status'] = false
          }
          return result && !that[current + 'Status']
        }, true)
        isValidate = that.seniorFileArray.reduce((result, current) => {
          if (that.addSeniorManage[current].length === 0) {
            that[current + 'Status'] = true
          } else {
            that[current + 'Status'] = false
          }
          return result && !that[current + 'Status']
        }, true)
        return isValidate
      } catch (error) {
      }
    },
    deleteSelected () {
      let that = this
      if (that.seniorManagementList.every(value => !value.checked)) {
        that.$message({
          type: 'warn',
          message: 'Please select the user to delete'
        })
        return false
      }
      that.$confirm('Do you confirm to delete this senior management?', 'warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        that.seniorManagementList = that.seniorManagementList.filter(value => !value.checked)
      })
    },
    showSeniorFile (index, type) {
      this.isShowFileImage = true
      if (type === 'id_proof') {
        this.fileArr = this.getUrlToFile(this.seniorManagementList[index].id_proof_file_list)
      } else if (type === 'address_proof') {
        this.fileArr = this.getUrlToFile(this.seniorManagementList[index].address_proof_file_list)
      }

      this.curFile = this.fileArr[0]
      this.isShowFileImage = true
      this.showSenior(this.curFile)
    },
    getUrlToFile (urls) {
      if (!urls) return
      let files = []
      urls.forEach((url) => {
        let lastNameIndex = url.lastIndexOf('/') + 1
        let fileName = url.substring(lastNameIndex)
        let lastTypeIndex = url.lastIndexOf('.') + 1
        let fileType = url.substring(lastTypeIndex)
        let file = {
          url: url,
          name: fileName,
          type: fileType,
          image: url,
          // size: this.formatSize(url.size),
          // date: this.formatDate(new Date()),
        }
        files.push(file)
      })

      return files
    },
    showImageInit (file, isShowFile) {
      this.curFile = file
      this.isShowFileImage = true
      this.showSenior(file)
    },
    showSenior (file) {
      if (!file) return
      let imageType = ['image/jpeg', 'image/png', 'jpg', 'jpeg', 'jpe', 'png']
      let fileType = [
        'application/pdf',
        'application/msword',
        'application/vnd',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'docx',
        'doc',
        'xls',
        'xlsx',
        'pdf',
      ]
      file = file.url || file
      if (imageType.some((type) => file.indexOf(type) > 0)) {
        this.bigImage = file
        this.fileUrl = null
      } else if (fileType.some((type) => file.indexOf(type) > 0)) {
        this.bigImage = ''
        this.fileUrl = file
      } else {
        this.bigImage = ''
        this.fileUrl = file
      }
    },
    closeFileImage () {
      this.bigImage = null
      this.isShowFileImage = false
      this.curFile = null
    },
    copyFunc (index) {
      let token = localStorage.getItem('Authorization')
      if (!this.seniorManagementList[index]) {
        return
      }
      if (this.kycStatus === 'firstEdit') {
        request({
          method: 'POST',
          url: `api/dashboard/merchant/kyc/copy?page_no=6&access_token=${token}`,
          data: JSON.stringify(this.seniorManagementList[index]),
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(res => {
          if (res.data.code === '10000') {
            this.$message({
              type: 'success',
              message: 'Copy success'
            })
          } else {
            this.$message({
              type: 'warn',
              message: res.data.msg
            })
          }
        })
      } else if (this.kycStatus === 'saved') {
        this.$emit('changeUltimateBeneficiary', this.seniorManagementList[index])
      }
    },
    editSenior (index) {
      this.editIndex = index
      this.seniorAddTitle = 'Edit'
      this.$refs.seniorAdd.open()
      let list = this.seniorManagementList[index]
      let currentIdType = this.idTypeOptions.filter(value => {
        return value.id === list.id_type
      })[0]
      let that = this
      this.addSeniorManage = {
        name: list.name,
        position: list.position,
        idNumber: list.id_number,
        residenceAddress: list.residence_address,
        pep: list.is_pep === 1 ? { id: 1, value: 'Yes' } : { id: 0, value: 'No' },
        sanction: list.is_sanction === 1 ? { id: 1, value: 'Yes' } : { id: 0, value: 'No' },
        crime: list.is_crime === 1 ? { id: 1, value: 'Yes' } : { id: 0, value: 'No' },
        idProof: list.id_proof_file_list,
        addressProof: list.address_proof_file_list,
        idType: currentIdType
      }
      if (!that.addSeniorManage.idType) {
        that.addSeniorManage.idType = {
          id: 1,
          value: 'ID'
        }
      }

      // this.$refs.mediumModal.close();
    },
    deleteFunc (index) {
      let that = this
      this.$confirm('Do you confirm to delete this senior management?', 'warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        that.seniorManagementList.splice(index, 1)
      })
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    uploadFile (files, type) {
      try {
        let curArray = this.addSeniorManage[type]
        if (curArray && curArray.length > 0) {
          this.changeStatusByType(type, false)
        }
      } catch (error) {}
    },
    removeFile (file, type) {
      try {
        let curArray = this.addSeniorManage[type]
        if (curArray && curArray.length > 0) {
          curArray = curArray.filter(image => {
            return file !== image
          })
          if (curArray.length === 0) {
            this.changeStatusByType(type, true)
          }
        }
      } catch (error) {}
    },
    changeStatusByType (type, flag) {
      try {
        this[type + 'Status'] = flag
      } catch (error) {}
    },
    // 多选 开始
    isIdTypeVaild (field) {
      let isValid = false
      if (this.idTypeStatus) {
        isValid = true
      }
      return isValid
    },
    isPepVaild (field) {
      let isValid = false
      if (this.pepStatus) {
        isValid = true
      }
      return isValid
    },
    isSanctionVaild (field) {
      let isValid = false
      if (this.sanctionStatus) {
        isValid = true
      }
      return isValid
    },
    isCrimeVaild (field) {
      let isValid = false
      if (this.crimeStatus) {
        isValid = true
      }
      return isValid
    },
    // forbiddenInput(val) {
    //   if (!val) {
    //     this.$refs.myInput.$el.getElementsByTagName("input")[0].style.height =
    //       "28px";
    //     this.pepStatus = true;
    //   } else {
    //     this.pepStatus = false;
    //   }
    // },
    // 多选 结束
    seniorCheckAll (event) {
      this.isList = false
      if (event.target.checked) {
        this.seniorManagementList.forEach((value) => {
          value.checked = true
        })
      } else {
        this.seniorManagementList.forEach((value) => {
          value.checked = false
        })
      }
      this.isList = true
      // console.log(this.seniorManagementList, 'this.list')
    },
    seniorCheckOne (event, index) {
      this.isList = false
      if (event.target.checked) {
        this.seniorManagementList[index].checked = true
      } else {
        this.seniorManagementList[index].checked = false
      }
      this.isList = true
    },
    // 保存
    saveSenior (cb) {
      if (this.seniorManagementList && this.seniorManagementList.length > 0) {
        let params = {
          page: 6,
          senior_management_list: this.seniorManagementList
        }
        this.$emit('updateKycInformation', params, function () {
          let flag = true
          cb(flag)
        })
      } else {
        this.$message({
          type: 'warn',
          message: 'At least one senior management'
        })
      }
    },
    getSenior (cb) {
      let senior = new Promise((resolve, reject) => {
        if (this.seniorManagementList.length > 0) {
          let params = {
            senior_management_list: this.seniorManagementList
          }
          resolve(params)
        } else {
          this.$message({
            type: 'warn',
            message: 'At least one senior management'
          })
        }
      })
      return senior
    },
    // 匹配id_type的key
    getIdTypeKey (value) {
      switch (value) {
        case 1:
          return 'ID'
        case 2:
          return 'Passport'
        case 3:
          return "Driver's License"
        case 4:
          return 'Other'
        default:
          return ''
      }
    },
    unique (arr) {
      if (!Array.isArray(arr)) {
        // console.log('type error!')
        return
      }
      var array = []
      for (var i = 0; i < arr.length; i++) {
        if (array.indexOf(arr[i]) === -1) {
          array.push(arr[i])
        }
      }
      return array
    },
    seniorCopyEnter (index) {
      this.$refs['seniorCopyFlag-' + index][0].className = 'senior-copy-flag'
    },
    seniorCopyLeave (index) {
      this.$refs['seniorCopyFlag-' + index][0].className = 'senior-copy-none'
    },
  },
}
</script>
<style lang="scss" scoped>
.senior-management {
  width: 100%;
  .form-group {
    width: 100%;
  }
  /deep/ .select-form-group {
    margin-bottom: 0;
  }
  /deep/ .vuestic-scrollbar {
    overflow-y: scroll;
  }

  .first-td-padding td:first-child {
    padding-left: 0.5rem !important;
  }

  .table th {
    text-align: center;
  }
  .table td {
    text-align: center;
  }
  // .table td:nth-of-type(3) {
  .table td {
    word-break: break-all;
  }
  .table td:nth-of-type(5) {
    white-space: nowrap;
  }
  .table tr {
    input[type="checkbox"] {
      margin-top: 5px;
    }
  }
  .alink {
    color: $vue-green;
    text-decoration: underline;
  }

  /*  增加详情页面 */
  table {
    text-align: center;
  }

  /deep/ #dategridPayOrder.vuestic-widget {
    .vuestic-widget-body {
      padding: 0;
    }
  }
  @media only screen and (max-width: 750px) {
    .mobile-btn {
      padding: 0.5rem 0.2rem 0;
    }

    /deep/ .pagination-container {
      padding: 5px 4px 10px;
      .el-pagination__total {
        display: block;
        margin-right: 4px;
      }
      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        margin: 0 2px 0;
      }
    }

    /deep/ .pagination-container {
      padding: 5px 4px 10px;
      .el-pagination {
        padding: 0;
      }
      .el-pagination__total {
        display: block;
        margin-right: 4px;
      }
      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        margin: 0 1px 0;
      }
    }

    /deep/ .buyer {
      padding-left: 5px;
      width: auto !important;
    }

    #paymentDetails {
      /deep/ .el-dialog {
        overflow: hidden;
        .vuestic-widget .vuestic-widget-body {
          overflow-x: auto;
          padding: 0.2rem;
        }
      }
    }
    #details {
      min-width: 600px;
    }
    /deep/ .merchant {
      margin-right: 20px;
    }
  }

  .senior-top {
    display: flex;
    flex-direction: row;
    .senior-title {
      float: left;
    }
    .senior-buttons {
      display: flex;
      flex-direction: row;
      .btn.btn-sm,
      .btn-group-sm > .btn {
        margin-right: 20px;
      }
    }
  }
  .action-button {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    img {
      width: auto;
      height: 25px;
      padding: 0 5px;
      cursor: pointer;
    }
  }

  .senior-td-button {
    position: relative;
  }

  .senior-copy-flag {
    border-radius: 8px;
    padding: 2px 15px;
    position: absolute;
    left: -50px;
    color: #fff;
    background: #000;
    white-space: nowrap;
    z-index: 10000;
  }

  .senior-copy-none {
    display: none;
  }

  /deep/ .upload-label {
    position: inherit;
  }
  /deep/ .app-logo-label-kyc {
    // width: 105px;
    white-space: nowrap;
    text-overflow: inherit;
    min-width: 33%;
  }
  /deep/ .app-logo-wrapper-kyc {
    white-space: nowrap;
    text-overflow: inherit;
    overflow: inherit;
    width: 67%;
  }
  /deep/ .mb0 {
    margin-bottom: 0;
  }
  /deep/ .saved-title {
    background-color: #eee;
    padding: 10px;
  }
}
</style>
